import gql from 'graphql-tag';

export const CREATE_SUPPLIER = gql`
  mutation createSupplier($createSupplierInput: CreateSupplierInput!) {
    createSupplier(createSupplierInput: $createSupplierInput) {
      id
      supplierName
      address
      contact
      status
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const UPDATE_SUPPLIER = gql`
  mutation updateSupplier($updateSupplierInput: UpdateSupplierInput!) {
    updateSupplier(updateSupplierInput: $updateSupplierInput) {
      id
      supplierName
      address
      contact
      status
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const REMOVE_SUPPLIER = gql`
  mutation removeSupplier($id: Int!) {
    removeSupplier(id: $id)
  }
`;
